import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); nav("/admin"); }
    catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center overflow-hidden bg-ink px-5">
      <div aria-hidden="true" className="absolute right-[-10%] top-[-20%] h-[560px] w-[560px] rounded-full bg-violet-700/30 blur-[140px]" />
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md rounded-[28px] border border-white/10 bg-white/[0.04] p-8 text-white backdrop-blur-xl sm:p-10">
        <img src="/brand/logo-white.png" alt="Perfect Digitals" className="h-11 w-auto" />
        <h1 className="mt-8 font-display text-3xl font-medium">Blog admin</h1>
        <p className="mt-2 text-sm text-slate-300">Sign in to write and publish Insights.</p>
        <label className="mt-8 block text-[13px] text-slate-300" htmlFor="email">Email</label>
        <input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email"
          className="mt-2 h-12 w-full rounded-xl border border-white/15 bg-white/5 px-4 text-white outline-none transition-colors focus:border-violet-400" />
        <label className="mt-5 block text-[13px] text-slate-300" htmlFor="password">Password</label>
        <input id="password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password"
          className="mt-2 h-12 w-full rounded-xl border border-white/15 bg-white/5 px-4 text-white outline-none transition-colors focus:border-violet-400" />
        {error && <p data-testid="admin-login-error" className="mt-4 rounded-xl bg-red-500/15 px-4 py-3 text-sm text-red-200">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit"
          className="mt-8 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-white font-semibold text-[#0B0716] transition-colors hover:bg-violet-200 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
